export const encodeFormUrl = objectInfo => {
    let details = {
        grant_type: 'password',
    };
    details = { ...details, ...objectInfo };
    let formBody = [];
    for (const property in details) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(details[property]);
        formBody.push(`${encodedKey}=${encodedValue}`);
    }
    return (formBody = formBody.join('&'));
};

export const decodeUrlForm = url => {
    let formDataObj = {};

    if (typeof url !== 'string' || !url.trim()) return formDataObj;

    const pairs = url.split('&');

    for (const pair of pairs) {
        if (!pair.includes('=')) continue; // ignorar pares sin '='

        const [key, ...valueParts] = pair.split('=');
        if (!key) continue; // ignorar claves vacías

        const decodedKey = decodeURIComponent(key);
        const decodedValue = decodeURIComponent(valueParts.join('=') || '');

        formDataObj[decodedKey] = decodedValue;
    }

    return formDataObj;
};
